<template>
  <div>
    <TitlePage :title="$t('test')+' '+$t('booking')"></TitlePage>

    <v-layout wrap>
      <p>Success</p>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "BookingsSuccess",
  components: {TitlePage},
  data() {
    return {
    }
  },
  async created() {
    this.setLoading(true);
    await this.confirmBooking()
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'confirm': 'bookings/confirm'
    }),

    async confirmBooking() {

      await this.setLoading(true);
      var result = await this.confirm({order:this.$route.query.token, payer_id: this.$route.query.PayerID})
      await this.setLoading(false);

      if (result) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

        this.$router.push('/bookings/test')

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },
  },
  mounted() {

  },
}
</script>

<style scoped>

</style>